/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IamRolePermission,
    IamRolePermissionFromJSON,
    IamRolePermissionFromJSONTyped,
    IamRolePermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetIamRolePermissionResponse
 */
export interface GetIamRolePermissionResponse {
    /**
     * 
     * @type {IamRolePermission}
     * @memberof GetIamRolePermissionResponse
     */
    iamRolePermission?: IamRolePermission;
}

export function GetIamRolePermissionResponseFromJSON(json: any): GetIamRolePermissionResponse {
    return GetIamRolePermissionResponseFromJSONTyped(json, false);
}

export function GetIamRolePermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIamRolePermissionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamRolePermission': !exists(json, 'iam_role_permission') ? undefined : IamRolePermissionFromJSON(json['iam_role_permission']),
    };
}

export function GetIamRolePermissionResponseToJSON(value?: GetIamRolePermissionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_role_permission': IamRolePermissionToJSON(value.iamRolePermission),
    };
}


